export default __webpack_public_path__ + "static/Staking_1-28d2ace883f88877ef4a40ee98abaad9.svg";